import { CopyToClipboard } from '@/components/ui/copy-to-clipboard'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Text } from '@/components/ui/text'
import { IReferralStatistics } from '@/data/referral'
import { CommonCopy } from '@/icons'
import { formatDate, formatTokenAmount, formatUSD, truncateAddress } from '@/utils'

import { useTranslation } from 'react-i18next'

interface HistoryProps {
  referrals?: IReferralStatistics['referrals']
}
export function History({ referrals }: HistoryProps) {
  const { t } = useTranslation()
  return (
    <Table className='overflow-auto'>
      <TableHeader>
        <TableRow className='border-white-10'>
          <TableHead className='text-white-48 py-3 px-2 min-w-40 md:w-[28%]'>{t('title.WALLET_ADDRESS')}</TableHead>
          <TableHead className='text-white-48 py-3 px-0 min-w-32 md:w-[14%]'>{t('title.JOINED_ON')}</TableHead>
          <TableHead className='text-white-48 py-3 px-0 text-center min-w-48 md:w-[28%]'>
            {t('title.NO_TRANSACTIONS')}
          </TableHead>
          <TableHead className='text-white-48 py-3 px-0 min-w-40 md:w-[14%]'>{t('title.VOLUME')}</TableHead>
          <TableHead className='text-white-48 py-3 px-2 min-w-32 md:w-[28%] text-right'>
            {t('title.REVENUE_SHARED')}
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {referrals?.map((referral) => (
          <TableRow key={referral.joinedOn} className='[&:not(:last-child)]:border-0'>
            <TableCell className='py-3 px-2 flex items-center gap-2'>
              <Text as='p'>{truncateAddress(referral.address)}</Text>
              <CopyToClipboard text={referral.address} copiedSuccessMessage={t('copy.COPY_ADDRESS_SUCCESS')}>
                <CommonCopy className='size-4' />
              </CopyToClipboard>
            </TableCell>
            <TableCell className='py-3 px-0 text-white-48'>
              {formatDate(referral.joinedOn, 'EEE dd MMM, HH:mm')}
            </TableCell>
            <TableCell className='py-3 px-0 text-white-48 text-center'>{referral.numberTxs}</TableCell>
            <TableCell className='py-3 px-0 text-white-48 '>
              {formatUSD(referral.totalVolumeUsd || 0, { showApproximateSign: false })}
            </TableCell>
            <TableCell className='py-3 px-2 text-white-48 text-right'>
              {formatTokenAmount(referral.revenueSharedUsd, 'USDT')} USDT
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
